"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _Button = _interopRequireDefault(require("../../Button"));
var _Plane = _interopRequireDefault(require("../../../icons-react/userflow/Plane"));
var SearcherEmptyButton = function SearcherEmptyButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledPre, null, t('hotel.searcher.emptyButton.text'), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    functional: true,
    onClick: onClick
  }, t('hotel.searcher.emptyButton.click'), /*#__PURE__*/_react["default"].createElement(StyledIconPlane, null)));
};
var StyledPre = _styledComponents["default"].span.withConfig({
  displayName: "SearcherEmptyButton__StyledPre",
  componentId: "sc-hpvbpn-0"
})(["white-space:pre;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SearcherEmptyButton__StyledButton",
  componentId: "sc-hpvbpn-1"
})(["color:", ";"], function (props) {
  return props.theme.colors.blue;
});
var StyledIconPlane = (0, _styledComponents["default"])(_Plane["default"]).withConfig({
  displayName: "SearcherEmptyButton__StyledIconPlane",
  componentId: "sc-hpvbpn-2"
})(["height:12px;path{stroke:", ";stroke-width:1.3px;}"], function (props) {
  return props.theme.colors.blue;
});
var _default = exports["default"] = SearcherEmptyButton;